import * as React from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import { GridContainer } from '@pec/aion-ui-components/components/GridContainer';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Tile } from 'components/Tile';
import { useTranslation } from 'react-i18next';
import { ReactComponent as HelpIcon } from '../../images/Help_Outlined.svg';
import { ReactComponent as SafetyIcon } from '../../images/Safety_Outlined.svg';
import { ReactComponent as TrainingIcon } from '../../images/Training_Outlined.svg';
import { ReactComponent as VeriforceHubIcon } from '../../images/Veriforce_Hub_Outlined.svg';

const styles = () => ({
  button: {
    width: '12rem',
    justifyContent: 'flex-start'
  },
  buttonIcon: {
    height: '1.5rem'
  }
});

type Props = WithStyles<typeof styles>;

const OfferingsTileComponent: React.FC<Props> = ({ classes }) => {
  const { t } = useTranslation();

  return (
    <Tile primaryText={t('subscriber:dashboard.offeringsTile.title', 'Veriforce Offerings')}>
      <GridContainer>
        <Grid item xs={12} lg={5}>
          <Button
            variant="outlined"
            color="primary"
            href="https://veriforce.com/solutions/pec-learn"
            target="_blank"
            startIcon={<TrainingIcon className={classes.buttonIcon} />}
            className={classes.button}
          >
            <Typography variant="button">
              {t('subscriber:dashboard.offeringsTile.viewTrainingOpportunities', 'View Training Opportunities')}
            </Typography>
          </Button>
        </Grid>
        <Grid item xs={12} lg={5}>
          <Button
            variant="outlined"
            color="primary"
            href="https://veriforce.com/resources/safety-meetings"
            target="_blank"
            startIcon={<SafetyIcon className={classes.buttonIcon} />}
            className={classes.button}
          >
            <Typography variant="button">
              {t('subscriber:dashboard.offeringsTile.accessSafetyMeetings', 'Access Safety Meetings')}
            </Typography>
          </Button>
        </Grid>
        <Grid item xs={12} lg={5}>
          <Button
            variant="outlined"
            color="primary"
            href="https://veriforce.com/hub"
            target="_blank"
            startIcon={<VeriforceHubIcon className={classes.buttonIcon} />}
            className={classes.button}
          >
            <Typography variant="button">
              {t('subscriber:dashboard.offeringsTile.veriforceHub', 'Veriforce Hub')}
            </Typography>
          </Button>
        </Grid>
        <Grid item xs={12} lg={5}>
          <Button
            variant="outlined"
            color="primary"
            href="https://veriforce.com/company/contact-us"
            target="_blank"
            startIcon={<HelpIcon className={classes.buttonIcon} />}
            className={classes.button}
          >
            <Typography variant="button">
              {t('subscriber:dashboard.offeringsTile.getAssistance', 'Get Assistance')}
            </Typography>
          </Button>
        </Grid>
      </GridContainer>
    </Tile>
  );
};

export const OfferingsTile = withStyles(styles)(OfferingsTileComponent);
